import { useMemo } from 'react';
import { preFixImgUrl } from '@/utils';
import { isAppLocale, type AppLocale } from '@/constants/appLocale';
import { TEMP_COUPON_STORES, type CouponLocaleText, type TempCouponStore } from './couponListInfo';

export { COUPON_STATIC_TEXT, TEMP_COUPON_STORES, type CouponLocaleText, type TempCouponStore } from './couponListInfo';
import customerIcon from '@/assets/svg/customer_icon.svg';
import attentionIcon from '@/assets/svg/attention_icon.svg';
import tanhaoIcon from '@/assets/svg/tanhao_icon.svg';

export const TEMP_COUPON_PAGE_SIZE = 9

const getCouponLocale = (language: string | undefined): AppLocale => {
  if (language && isAppLocale(language)) return language
  return 'zh_CN'
}

const isChineseLocale = (language: string | undefined) => {
  const locale = getCouponLocale(language)
  return locale === 'zh_CN' || locale === 'zh_TW'
}

export function getCouponLocaleText(text: CouponLocaleText, language: string | undefined): string {
  return text[getCouponLocale(language)]
}

export function formatCouponParticipants(
  participantCount: string,
  participantsSuffix: CouponLocaleText,
  language: string | undefined,
): string {
  const suffix = getCouponLocaleText(participantsSuffix, language)
  return `${participantCount} ${suffix}`
}

/** 详情展示用最终图片 */
export function getTempCouponDetailImageFile(store: TempCouponStore, language: string | undefined): string {
  return isChineseLocale(language) ? store.detailImageZhFile : store.detailImageEnFile
}

export function getTempCouponById(id: string | null | undefined): TempCouponStore | undefined {
  if (!id) return undefined
  return TEMP_COUPON_STORES.find((s) => s.id === id)
}

export type CouponQuickLinkItem =
  | { key: string; iconImg: string; to: string }
  | { key: string; iconImg: string; href: string };

const COUPON_LIST_QUICK_LINKS = [
  {
    key: 'coupon.list.quickLinks.terms',
    iconFile: attentionIcon,
    to: '/items',
  },
  {
    key: 'coupon.list.quickLinks.precautions',
    iconFile: tanhaoIcon,
    to: '/coupon-precautions',
  },
  {
    key: 'coupon.list.quickLinks.contact',
    iconFile: customerIcon,
    href: 'mailto:info.japanmall@jdxjp.net',
  },
] as const;

export default function useModel() {
  const quickLinks = useMemo<CouponQuickLinkItem[]>(
    () =>
      COUPON_LIST_QUICK_LINKS.map((row) => {
        const base = {
          key: row.key,
          iconImg: row.iconFile,
        };
        if ('href' in row) {
          return { ...base, href: row.href };
        }
        return { ...base, to: row.to };
      }),
    [],
  );

  return { quickLinks };
}
